import { render, staticRenderFns } from "./ImportSalary.vue?vue&type=template&id=e94198ce&"
import script from "./ImportSalary.vue?vue&type=script&lang=js&"
export * from "./ImportSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports